// Foreva Jewels tiled hero (sections/fj-hero-tiles.liquid).
//
// One panel at a time moves to its next photo, in a mixed order, so a single soft change happens every
// (seconds / panels). Runs only while the hero is on screen and the tab is visible; nothing moves with
// reduced motion. Works again after theme-editor section reloads.

const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

/** @param {HTMLElement} hero */
function init(hero) {
  if (hero.dataset.fjhReady) return;
  hero.dataset.fjhReady = '1';

  const panels = [...hero.querySelectorAll('.fjh__panel')].filter((p) => p.querySelectorAll('.fjh__img').length > 1);
  if (!panels.length || reduceMotion) return;

  // Mixed order (e.g. 0, 3, 1, 4, 2) so neighbouring panels don't change one after another.
  const half = Math.ceil(panels.length / 2);
  const order = [];
  for (let i = 0; i < half; i++) {
    order.push(i);
    if (i + half < panels.length) order.push(i + half);
  }

  const seconds = Number(hero.dataset.seconds) || 10;
  let step = 0;
  let timer = 0;
  // Assume on screen until the observer says otherwise (it can report late, or not at all in hidden frames).
  let visible = true;

  const advance = () => {
    // Only panels that are showing (phones hide the inner ones).
    const live = order.map((i) => panels[i]).filter((p) => p.offsetParent !== null);
    if (!live.length) return;
    const imgs = [...live[step++ % live.length].querySelectorAll('.fjh__img')];
    const cur = Math.max(0, imgs.findIndex((im) => im.classList.contains('is-on')));
    const next = imgs[(cur + 1) % imgs.length];
    imgs.forEach((im) => im.classList.remove('is-out'));
    imgs[cur].classList.replace('is-on', 'is-out');
    if (next instanceof HTMLImageElement) next.loading = 'eager';
    void next.offsetWidth;
    next.classList.add('is-on');
  };

  const run = () => {
    clearInterval(timer);
    timer = 0;
    if (visible && !document.hidden && hero.isConnected) timer = window.setInterval(advance, (seconds * 1000) / order.length);
  };

  new IntersectionObserver(([entry]) => {
    visible = Boolean(entry?.isIntersecting);
    run();
  }).observe(hero);
  document.addEventListener('visibilitychange', run);
  run();
}

const initAll = () => document.querySelectorAll('.fjh').forEach((el) => el instanceof HTMLElement && init(el));
initAll();
document.addEventListener('shopify:section:load', initAll);
